export const saveConsent = (status) => {
  localStorage.setItem("user_consent", JSON.stringify(status));
};

export const loadConsent = () => {
  const item = localStorage.getItem("user_consent");
  return item ? JSON.parse(item) : null;
};